import { registerLicense } from '@syncfusion/ej2-base';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { AppRouter } from './AppRouter';
import './index.css';

import { loadConfig } from '@utils/configLoader';
import AuthSessionRestorer from 'src/auth/components/AuthSessionRestorer';
import { oidcService } from 'src/services/oidcService';
import store from 'src/store';

const config = await loadConfig();

// Handle OIDC callback pre-React (hash router compatibility — AD-5)
const searchParams = new URLSearchParams(window.location.search);
if (searchParams.has('code') && searchParams.has('state')) {
  await oidcService.handleCallback();
  window.history.replaceState({}, document.title, window.location.pathname);
}

// Registering Syncfusion license key
if (config.appEnv === 'development' && process.env.SYNCFUSION_LICENSE) {
  registerLicense(process.env.SYNCFUSION_LICENSE);
}

console.log('Environment:', config.appEnv);
console.log('Build:', config.build);

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!, {
  onUncaughtError: (error, info) => {
    console.error('Uncaught error:', error, info);
  },
  onCaughtError: (error, info) => {
    console.warn('Caught by error boundary:', error, info);
  },
});
root.render(
  <Provider store={store}>
    <AuthSessionRestorer />
    <RouterProvider router={AppRouter} />
  </Provider>
);
